import React, { useState } from "react";
import logo from "../../assets/logo/logo.png";
import { Link, useNavigate } from "react-router-dom";
import { fetchProfile, login } from "../../api/UserApi";
import { setAccessToken } from "../../axioxClient.ts/axiosClient";
import { useUser } from "../../context/UserContext";
import { dynamicSuccess } from "../../hooks/useToast";
import { useLoader } from "../../context/LoaderContext";
import { Eye, EyeOff } from "lucide-react";

const Login = () => {
  const { setLoading } = useLoader();
  const navigate = useNavigate();
  const { setUser } = useUser();
  const [form, setForm] = useState({
    emailOrPhone: "",
    password: "",
  });
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setErrorMessage("");
    try {
      const res = await login(form.emailOrPhone, form.password);
      setAccessToken(res.data.access_token);
      await fetchProfile().then((userData) => {
        if (userData) {
          setUser(userData);
        }
      });
      dynamicSuccess("Login successfully!");
      navigate("/");
    } catch (err: any) {
      if (!err?.response) {
        setErrorMessage("! Unable to connect to the server !");
      } else {
        if (err.response.status >= 500) {
          setErrorMessage("! Server error occurred !");
        } else {
          setErrorMessage("! Email address or Password incorrect !");
        }
      }
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };
  return (
    <div className="login-container d-flex justify-content-center align-items-center p-3">
      <div className="login-box text-center">
        <div className="logo mb-3">
          <img src={logo} alt="logo" className="logo-img" />
        </div>

        <h1 className="welcome-text mb-4">Welcome!</h1>

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <input
              type="text"
              name="emailOrPhone"
              className={`form-control custom-input ${errorMessage ? "input-error" : ""}`}
              placeholder="Your Email Address"
              value={form.emailOrPhone}
              onChange={handleChange}
            />
          </div>

          <div className="mb-4 password-input-wrapper">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              className={`form-control custom-input ${errorMessage ? "input-error" : ""}`}
              placeholder="Password"
              value={form.password}
              onChange={handleChange}
            />
            <button
              type="button"
              className="password-toggle-btn"
              onClick={() => setShowPassword(!showPassword)}
              tabIndex={-1}
            >
              <i className="password-toggle-icon">
                {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
              </i>
            </button>
          </div>

          <button type="submit" className="btn btn-danger w-100 custom-btn">
            Login
          </button>
          {errorMessage && (
            <div className="text-error mt-2">{errorMessage}</div>
          )}
        </form>

        {errorMessage && (
          <p className="mt-3 mb-1 signup-text">
            Did you forget your password{" "}
            <Link to="/reset-password" className="signup-link">
              Reset Password
            </Link>
          </p>
        )}
        <p className={`signup-text ${!errorMessage ? "mt-3" : ""}`}>
          Don’t have an account{" "}
          <span className="signup-link">Sign up here!</span>
        </p>
      </div>
      <div className="login-footer">
        <p className="mb-0">
          Copy Right{" "}
          <span className="table-bold">Lalitpur Metropolitan City</span>
        </p>
        <p>
          Designed By <span className="table-bold">Nhuniq Labs</span>
        </p>
      </div>
    </div>
  );
};

export default Login;
